import React, { useEffect } from 'react';
import { Card } from "react-bootstrap";
import annIcon from "assets/img/ann-icon.png";
import { useDispatch, useSelector } from 'react-redux';
import { getPublishedAnnouncements } from '../../../redux/slice/announcementsSlice';
import { useNavigate } from 'react-router-dom';
import PublishedToggleableContent from './PublishedToggleableContent';
import AnnouncementAction from './AnnouncementAction';
import { toast, ToastContainer } from "react-toastify";

export default function PublishedAnnouncementList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { publishedList = [], publishedStatus } = useSelector(
        (state) => state.announcements
    );

    useEffect(() => {
        dispatch(getPublishedAnnouncements({ page: "0", size: "10" }))
    }, [dispatch]);

    return (
        <Card className="graph-card">
            <Card.Header>
                <div className="post-heading-btn-container">
                    <div className="d-flex align-items-center">
                        <img src={annIcon} className="action-icon mr-1" />
                        <Card.Title as="h4" className="graph-heading">Announcements</Card.Title>
                    </div>
                    {/* <div>
                        <button type="button" className="primary-btn" onClick={() => navigate("/admin/announcements")}>View All</button>
                    </div> */}
                </div>
            </Card.Header>
            <hr></hr>
            <Card.Body className="publishedAnn">
                {publishedStatus === "loading" && <p className="loading-msg">Loading announcement...</p>}
                {publishedStatus === "failed" && <p className="server-error-msg">Unable to connect to server</p>}
                {publishedStatus === "succeeded" && publishedList?.length === 0 && (<p className='server-error-msg'>--No record for announcement--</p>)}
                {publishedStatus === "succeeded" && publishedList?.length > 0 &&
                    (<ul>
                        {publishedList.map((item) => {
                            const displayDate = item.publishedAt
                                ? new Date(item.publishedAt).toLocaleString()
                                : "-";
                            return (
                                <li key={item.id}>
                                    <h6 className="text-muted small">{displayDate}</h6>
                                    <h6>{item.title}</h6>
                                    <PublishedToggleableContent key={item.id} item={item} />
                                    <AnnouncementAction item={item}/>
                                    <hr/>
                                </li>
                            )
                        })
                        }
                    </ul>
                    )}
            </Card.Body>
            <ToastContainer/>
        </Card>
    )
}
